import { File, FileFigmaRenderMode, FileReference, FileSource, FileSourceUpload, FileSourceFigma, } from "@supernova-studio/model";
import z from "zod";
//
// Entity
//
export const DTOFileFigmaRenderMode = FileFigmaRenderMode;
export const DTOFileSourceUpload = FileSourceUpload;
export const DTOFileSourceFigma = FileSourceFigma;
export const DTOFileSource = FileSource;
export const DTOFile = File;
export const DTOFileReference = FileReference;
//
// Input Payloads
//
const DTOFileUploadOwnerUser = z.object({
    ownerType: z.literal("User"),
});
const DTOFileUploadOwnerWorkspace = z.object({
    ownerType: z.literal("Workspace"),
    workspaceId: z.string(),
});
const DTOFileUploadOwner = z.discriminatedUnion("ownerType", [
    DTOFileUploadOwnerUser,
    DTOFileUploadOwnerWorkspace,
]);
const DTOFileUploadInput = z.object({
    size: z.number(),
    name: z.string(),
    checksum: z.string(),
});
export const DTOFileUploadBulkPayload = z
    .object({
    files: DTOFileUploadInput.array(),
})
    .and(DTOFileUploadOwner);
export const DTOFileFinalizeBulkPayload = z
    .object({
    fileIds: z.string().array(),
})
    .and(DTOFileUploadOwner);
//
// Output Payloads
//
export const DTOFileListResponse = z.object({
    files: DTOFile.array(),
});
export const DTOFileUploadBulkResponse = z.object({
    files: z.array(DTOFile),
    uploadUrls: z.array(z.object({
        fileId: z.string(),
        uploadUrl: z.string(),
    })),
});
export const DTOFileFinalizeBulkResponse = z.object({
    files: z.array(DTOFile),
});
